import { SPAN_REMOVE_MOBILE_SIM } from '@constants/otel';
import { ProductType } from '@generated/gql/graphql';
import { useUpdatedTariffModalContext } from '@providers/basket/UpdatedTariffModalProvider/Context';
import { useTrace } from '@services/otel';
import { UpdatedTariffModalVariant } from '@src/types/bundle';

import { useSimsStore } from '../store';

const useRemoveSim = () => {
  const { withTrace } = useTrace();
  const { removeSim: removeSimStore } = useSimsStore();
  const { setModalState } = useUpdatedTariffModalContext();

  const executeRemoveSim = async (simId: string) => {
    removeSimStore(simId);
    setModalState(UpdatedTariffModalVariant.productRemoved, [
      ProductType.Mobile,
    ]);
  };

  const removeSim = (simId: string) =>
    withTrace(SPAN_REMOVE_MOBILE_SIM, () => executeRemoveSim(simId), { simId });

  return { removeSim };
};

export { useRemoveSim as useRemoveMobileQuote };
